import * as React from "react";
import styled from "styled-components";
const Container = styled.i`
  color: darkgray;
`;
const EmptyValue = () => /* @__PURE__ */ React.createElement(Container, null, "<Empty Value>");
export default EmptyValue;
